
let dialog = {
    /* 添加用户 */
    addUser: '添加用户',
    editUser: '修改用户',
    userInfo: '用户信息',
    username: '用户名',
    password: '密码',
    confirmPass: '重复密码',
    userGroup: '用户组',
    Superior: '上级',
    mobile: '手机号',
    checkGroup: '是否查看账户组',
    checkMobile: '是否查看联系方式',
    lock: '是否锁定登录',
    /* 添加用户组 */
    addUserGroup: '添加用户组',
    groupName: '用户组名',
    groupDesc: '用户组描述',
    /* 修改用户 */
    systemAdmin: '系统管理员',
    introducedBroker: '介绍经纪商',
    /* 修改用户组 */
    editGroupInfo: '修改用户组信息',
    /* 修改用户组权限 */
    editUserAuth: '修改用户权限',
    /* 添加下级用户 */
    addLowerUser: '添加下级用户',
    /* 修改出金申请信息 */
    editWithdraw: '修改出金申请信息',
    /* 添加佣金信息 */
    editBankcardInfo: '修改出金银行卡信息'

}

export default dialog;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/dialog.js